import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../../../Config/Config";

const FilterTreeEditBlock = ({ show, onClose, BlockData, onSuccess }) => {
  // ✅ Hooks MUST be at top level
  // const [ahuName, setAhuName] = useState("");

  console.log(BlockData, "blockdata");

  const [blockNameInput, setBlockNameInput] = useState("");
  const [blockDescription, setBlockDescription] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  // const [formData, setFormData] = useState({
  //   BlockName: "",
  //   Description: "",
  // });
  const [loading, setLoading] = useState(false);
  console.log(loading);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  console.log(error);
  const [authLoading, setAuthLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  // ✅ Return AFTER hooks

  useEffect(() => {
    if (BlockData) {
      setBlockNameInput(BlockData.BlockName || "");
      setBlockDescription(BlockData.Description || "");
    }
  }, [BlockData]);

  if (!show) return null;

  const handleSave = async () => {
    if (!blockNameInput) {
      alert("Branch Name is required");
      return;
    }

    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "addLocation",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    const payload = {
      BlockId: BlockData?.BlockId,
      BlockName: blockNameInput,
      Description: blockDescription,
      UpdatedBy: user?.UserID,
      IsLocationType: BlockData?.isLocationType,
    };

    console.log(payload, "payload");

    try {
      setLoading(true);

      const response = await fetch(`${getApiBaseUrl()}/api/editlocations`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      const status = result?.ResultData?.[0];

      if (response.ok && status?.Status === "Success") {
        await logActivity(
          true,
          `Block "${blockNameInput}" Edited successfully`,
        );
        // setFormData({ BlockName: "", Description: "" });
        setBlockDescription(" ");
        setBlockNameInput(" ");

        Swal.fire("Success", "Block Edited successfully!", "success").then(
          () => {
            onSuccess(); // 🔥 reload ONLY areas
            onClose(); // close modal
          },
        );
      } else {
        await logActivity(false, `Block "${blockNameInput}" Edit failed`);
        Swal.fire("Failed", "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Network error:", error);
      await logActivity(
        false,
        `Block "${blockNameInput}" creation failed: ${error.message}`,
      );
      Swal.fire("Error", "Unable to connect to server.", "error");
    } finally {
      setLoading(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!blockNameInput || !blockDescription) {
      setError(
        "Please fill in all required fields: Block Name and Description.",
      );
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill in all required fields: Block Name and Description.",
      });
      return;
    }

    if (!user?.UserID) {
      setError("Invalid user data. Please log in again.");
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    setAskPassword(true);
  };

  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSave();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <>
      {/* Modal */}
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Block</h5>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  fontWeight: "bold",
                  lineHeight: "1",
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <>
                <div className="row">
                  {/* Branch / Block Name */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Branch Name *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Block Name"
                      value={blockNameInput}
                      onChange={(e) => setBlockNameInput(e.target.value)}
                    />
                  </div>

                  {/* Description */}
                  <div className="col-md-8 mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      placeholder="Enter description"
                      rows="3"
                      value={blockDescription}
                      onChange={(e) => setBlockDescription(e.target.value)}
                    />
                  </div>
                </div>

                {askPassword && (
                  <div className="mt-2">
                    <div className="mb-3 w-lg-75 m-auto">
                      <label className="form-label">
                        Confirm Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="pass-input form-control"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setError("");
                          }}
                          onCopy={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          placeholder="Enter Password"
                        />
                        <span
                          className={`ti toggle-password ${
                            showPassword ? "ti-eye" : "ti-eye-off"
                          }`}
                          onClick={() => setShowPassword(!showPassword)}
                        ></span>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary btn-sm me-2"
                      onClick={handleAuth}
                      disabled={authLoading || !password}
                    >
                      {authLoading ? "Verifying..." : "Confirm"}
                    </button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        setAskPassword(false);
                        setPassword("");
                        setError("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </>
            </div>
            {askPassword && (
              <div className="modal-footer gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />
    </>
  );
};

FilterTreeEditBlock.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,

  BlockData: PropTypes.shape({
    BlockId: PropTypes.number.isRequired,
    BlockName: PropTypes.string,
    Description: PropTypes.string,
    isLocationType: PropTypes.string,
  }).isRequired,
};

export default FilterTreeEditBlock;
